import { MenuIcon } from '@cmp-src/icons/TacticIcons/MenuIcons';
import { cn } from '@gettactic/helpers';
import { Button, ButtonProps } from '@v2/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@v2/components/ui/dropdown-menu';

import { JoinButton } from '../JoinButton/JoinButton';
import { ISchedule } from '@gettactic/api';

const borderClass = 'border-1';

const hoverClass = `hover:${borderClass} hover:border-neutral-500 hover:shadow-md`;

// adjust top div className when changing this
const cardRounded = 'xl';

// reason for this spacings is to accommodate the rainbow border
// those got to be same size, but in separate strings
const pbToCompensateButton = 'pb-[3px]';
const mRainbow = 'm-[3px]';
const mxRainbow = 'mx-[3px]';
export const pxRainbow = 'px-[3px]';
// <-- those got to be same size

export interface AgendaCardLayoutProps {
  topLeft?: React.ReactNode;
  topRight?: React.ReactNode;
  bottomLeft?: React.ReactNode;
  bottomRight?: React.ReactNode;
  button?: React.ReactNode;
  onCardClick?: () => void;
  dotsMenu?: React.ReactNode;
  isSelected?: boolean;
  hasHover?: boolean;
}

export const AgendaCardLayout = ({
  topLeft,
  topRight,
  bottomLeft,
  bottomRight,
  button,
  onCardClick,
  dotsMenu,
  hasHover,
  isSelected
}: AgendaCardLayoutProps) => {
  return (
    <div
      className={cn(
        'group/card flex flex-col',
        'rounded-2xl',
        !!button && pbToCompensateButton
      )}
      style={
        isSelected
          ? {
              backgroundImage: 'var(--rainbow)'
            }
          : {}
      }
    >
      <div
        onClick={onCardClick}
        className={cn(
          mRainbow,
          `z-10 cursor-pointer ${borderClass} border-transparent bg-background text-sm`,
          'p-3',
          `rounded-${cardRounded}`,
          hasHover && !isSelected && hoverClass,
          isSelected ? 'border-primary' : 'border-neutral-200'
        )}
      >
        <div className="flex justify-between">
          {!!(topLeft || topRight) && (
            <div className="flex items-center justify-between">
              {topLeft}
              {topRight}
            </div>
          )}
          {dotsMenu}
        </div>
        {!!(bottomLeft || bottomRight) && (
          <div className="mt-4 flex justify-between">
            {bottomLeft}
            {bottomRight}
          </div>
        )}
      </div>
      {!!button && <div className={`-mt-14 pt-8 ${mxRainbow}`}>{button}</div>}
    </div>
  );
};

export interface DotsMenuProps {
  onlineMeeting?: ISchedule['online_meeting'] | null;
  onRemove?: () => void;
  onManage?: () => void;
  canRemove?: boolean;
  canManage?: boolean;
  onRefetch?: () => void;
}

export const DotsMenu = ({
  onRemove,
  onManage,
  canRemove = true,
  canManage = true,
  onlineMeeting,
  onRefetch
}: DotsMenuProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="outline-none">
          <span className="hidden px-2 group-hover/card:block">
            <MenuIcon className=" " />
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <JoinButton
          onlineMeeting={onlineMeeting}
          iconOnly={false}
          onRefetch={onRefetch}
          wrapper={(children, icon, props) => (
            <DropdownMenuItem
              onClick={(e) => {
                e.stopPropagation();
                if (props.onClick) props.onClick(e);
              }}
              disabled={props.disabled}
            >
              {icon}
              {children}
            </DropdownMenuItem>
          )}
        />
        {canManage && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              if (onManage) onManage();
            }}
          >
            Manage
          </DropdownMenuItem>
        )}
        {canRemove && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              if (onRemove) onRemove();
            }}
            className=""
          >
            Remove
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const AgendaCardButton = (props: ButtonProps) => {
  return (
    <Button
      className={cn(
        'h-16 w-full pt-7',
        `rounded-${cardRounded}`,
        props.className
      )}
      {...props}
    />
  );
};
